import React from 'react';
import PropTypes from 'prop-types';
import { withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps';
import { MapStyle } from './../constants';
import { PartnerHotels as S } from './../styles';

class Map extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    this.state = {
      activeMarker: null,
    };
  }
  onMarkerClick = (id) => {
    this.setState({
      activeMarker: id,
    });
  }
  handleClick = (hotel) => {
    this.props.modal(true);
    this.props.selectedHotel(hotel);
  }
  render() {
    const { hotels } = this.props;
    const { activeMarker } = this.state;
    return (
      <S.Map>
        <GoogleMap {...MapStyle} style={{ position: 'relative' }} onClick={() => this.onMarkerClick(null)}>
          { hotels.map((hotel) => (
            <Marker
              key={hotel.name}
              position={{ lat: hotel.position.lat, lng: hotel.position.lng }}
              icon={hotel.marker}
              title={hotel.name}
              onClick={() => this.onMarkerClick(hotel.id)}
              clickable={!hotel.featured}
            >
              {activeMarker === hotel.id ? (
                <InfoWindow marker={activeMarker}>
                  <S.InfoWindow>
                    <img src={hotel.images[0]} alt={hotel.name} />
                    <h3>{hotel.name}</h3>
                    <button onClick={() => this.handleClick(hotel)} data-hotel-name={hotel.name}>See Rooms</button>
                  </S.InfoWindow>
                </InfoWindow>
              ) : null }
            </Marker>
          )) }
        </GoogleMap>
      </S.Map>
    );
  }
}

Map.propTypes = {
  hotels: PropTypes.array.isRequired,
  modal: PropTypes.func.isRequired,
  selectedHotel: PropTypes.func.isRequired,
};

export default withGoogleMap(Map);



// WEBPACK FOOTER //
// ./src/containers/Hotel/PartnerHotels/Map.js